import React, { Component } from "react";

import LabelField from './label-field';

class DateField extends Component {
  constructor(props) {
    super(props);

    this.state = {value: ''};

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  componentDidMount() {
    if (this.props.answer) {
      this.setState({ value: this.props.answer.answer });
    }
  }

  onChange(event) {
    this.setState({ value: event.currentTarget.value });
  }
  onBlur(event) {
    const answers = (this.props.answer) ? [this.props.answer.answer] : ["", null, undefined];
    if ( !answers.includes(event.currentTarget.value) ) {
      const payload = {
        field_type: this.props.masterQuestion.type,
        master_question_id: this.props.masterQuestion.id,
        master_question_choice_id: null,
        answer: event.currentTarget.value
      };

      this.props.saveCompletedSurveyAnswer(payload);
    }
  }

  render() {
    let column_one = null;
    let column_two = null;
    const field = (
      <input
        type="date"
        name={this.props.masterQuestion.question_uuid}
        id={this.props.masterQuestion.question_uuid}
        onChange={this.onChange}
        onBlur={this.onBlur}
        value={this.state.value}
      />
    );

    if (this.props.masterQuestion.question_label) {

      column_one = (
        <LabelField
          masterQuestion={this.props.masterQuestion}
        />
      );

    }

    column_two = field;

    return (
      <div className="form-group">
        <div className="row">

          <div className="col-md-6">
            {column_one}
          </div>

          <div className="col-md-6">
            {column_two}
          </div>

        </div>
      </div>
    );

  }
}

export default DateField;
